export const GA_ID = 'G-0VS0J7BCQX';
export const AW_ID = 'AW-18380586351';

// Optional Google Ads conversion labels (AW-18380586351/<label>). Leave empty to rely on GA4 import.
export const ADS_CONVERSION_LABELS = {
  generate_lead: '',
  click_call: '',
  click_whatsapp: '',
  click_quote: '',
};

const DENIED = {
  ad_storage: 'denied',
  ad_user_data: 'denied',
  ad_personalization: 'denied',
  analytics_storage: 'denied',
};
const GRANTED = Object.fromEntries(Object.keys(DENIED).map((k) => [k, 'granted']));

function gtag() {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(arguments);
}

export const track = (name, params = {}) => {
  gtag('event', name, { ...params, page_path: window.location.pathname });
  const label = ADS_CONVERSION_LABELS[name];
  if (label) gtag('event', 'conversion', { send_to: `${AW_ID}/${label}` });
};

const installClickTracking = () => {
  document.addEventListener('click', (e) => {
    const a = e.target.closest?.('a');
    if (!a || window.location.pathname.startsWith('/admin')) return;
    const href = a.getAttribute('href') || '';
    const explicit = a.dataset.track;
    if (explicit) track(explicit, { element_id: a.dataset.testid || '' });
    else if (href.startsWith('tel:')) track('click_call', { element_id: a.dataset.testid || '' });
    else if (href.includes('wa.me')) track('click_whatsapp', { element_id: a.dataset.testid || '' });
  });
};

// Consent Mode v2: tags load with every signal denied (cookieless pings only) until the user accepts.
export const initGtag = () => {
  if (window.__gtagLoaded) return;
  window.__gtagLoaded = true;
  window.gtag = gtag;
  gtag('consent', 'default', { ...DENIED, wait_for_update: 500 });
  gtag('js', new Date());
  gtag('config', GA_ID);
  gtag('config', AW_ID, { allow_enhanced_conversions: true });
  const s = document.createElement('script');
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  installClickTracking();
};

export const grantConsent = () => gtag('consent', 'update', GRANTED);
